import React, { useState } from "react";
import Modal from "react-modal";

// Styles for the modal
const customStyles = {
  content: {
    width: "400px",
    height: "200px",
    margin: "auto",
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "20px",
  },
};

// Set the root element for the modal
Modal.setAppElement("#root");
// Component
const Popup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
        <h2>Modal Title</h2>
        <p>Modal content goes here...</p>
        <button onClick={closeModal}>Close Modal</button>
      </Modal>
    </>
  );
};

export default Popup;
